// Utilidades para teléfonos de Paraguay (+595)

// Limpia el input dejando solo dígitos
export function onlyDigits(value: string): string {
  return (value || '').replace(/\D+/g, '');
}

// Formatea a +595 AA BBB CCCC o +595 9AA BBB BBB para móviles
// Acepta entradas con o sin +595, espacios o guiones
export function formatPyPhone(input: string): string {
  const raw = onlyDigits(input);

  // Quitar prefijo local 0 si existe al inicio
  const stripped = raw.startsWith('0') ? raw.slice(1) : raw;

  // Quitar país si ya vino con 595
  const noCountry = stripped.startsWith('595') ? stripped.slice(3) : stripped;

  // Caso móviles: 9 + 2 dígitos de área + 6 dígitos (total 9)
  if (noCountry.length >= 9 && noCountry[0] === '9') {
    const a = noCountry.slice(0, 3); // 9AA
    const b = noCountry.slice(3, 6); // BBB
    const c = noCountry.slice(6, 9); // BBB
    return `+595 ${a} ${b}${c ? ' ' + c : ''}`.trim();
  }

  // Caso línea fija: 2 a 3 dígitos de área + 6 a 7 dígitos
  const area = noCountry.slice(0, 2);
  const rest = noCountry.slice(2);
  const b = rest.slice(0, 3);
  const c = rest.slice(3, 7);
  const formatted = `+595 ${area}${b ? ' ' + b : ''}${c ? ' ' + c : ''}`.trim();
  return formatted;
}

// Valida rápida: debe tener prefijo +595 y al menos 9 dígitos locales (móviles)
export function isValidPyPhone(formatted: string): boolean {
  const digits = onlyDigits(formatted);
  if (!digits.startsWith('595')) return false;
  const local = digits.slice(3);
  // Móviles: 9XXXXXXXX (9 dígitos) | Fijo: >= 8 dígitos
  return local.length >= 8 && local.length <= 9;
}

// Quita el prefijo país si viene en el valor
export function stripCountryPrefix(input: string): string {
  const digits = onlyDigits(input);
  const local = digits.startsWith('595') ? digits.slice(3) : digits;
  return local;
}

// Formatea SOLO la parte local (sin +595). Ej: "981123456" -> "981 123 456"
export function formatPyLocal(input: string): string {
  const local = stripCountryPrefix(input);
  // Móvil (9AA BBB BBB)
  if (local.length >= 9 && local[0] === '9') {
    const a = local.slice(0, 3);
    const b = local.slice(3, 6);
    const c = local.slice(6, 9);
    return [a, b, c].filter(Boolean).join(' ').trim();
  }
  // Fijo (AA BBB BBB o A BBB BBB)
  const a = local.slice(0, 2);
  const b = local.slice(2, 5);
  const c = local.slice(5, 9);
  return [a, b, c].filter(Boolean).join(' ').trim();
}

// Compone E.164 a partir de parte local (sin espacios)
export function composeE164FromLocal(localFormatted: string): string {
  const localDigits = onlyDigits(localFormatted);
  if (!localDigits) return '';
  return `+595 ${localDigits}`.trim();
}
